import gql from 'graphql-tag'

export const RESET_PASSWORD_WITH_MUTATION = gql`
mutation ResetPasswordMutation(
  $password: String!
  $token: String!
) {
  resetPassword(password: $password, token: $token)
}
`



// WEBPACK FOOTER //
// ./src/mutations/RESET_PASSWORD_MUTATION.ts